<template>
  <div
    v-if="enableHistory"
    class="search-history-fi"
  >
    <search-history-slider-fi
      :history-active
      class="search-history-fi__slidein"
    />
  </div>
</template>

<script setup lang="ts">
import { defineAsyncComponent, ref, watchEffect } from 'vue';

import { useBreakpoints } from '@/composables/breakpoint';
import { useNavigationStore } from '@/store/pinia/navigation';
import { useSearchStore } from '@/store/pinia/search';

const SearchHistorySliderFi = defineAsyncComponent(() => import('./SearchHistorySliderFi.vue'));

defineOptions({
  name: 'SearchHistoryFi',
});

const props = defineProps<{
  lg?: boolean;
}>();

const navigationStore = useNavigationStore();
const searchStore = useSearchStore();
const { isLG } = useBreakpoints();

const enableHistory = ref(false);
const historyActive = ref(false);

watchEffect(() => {
  if (IS_SSR) {
    return;
  }
  if (props.lg) {
    if (!isLG.value) {
      enableHistory.value = false;
      return;
    }
  } else if (isLG.value) {
    enableHistory.value = false;
    return;
  }
  if (searchStore.queryTrimmed.length > 0) {
    historyActive.value = false;
    return;
  }
  if (navigationStore.searchFocused || (!isLG.value && navigationStore.searchActive)) {
    enableHistory.value = true;
    historyActive.value = true;
    return;
  }
  if (historyActive.value) {
    // use timeout to let click handlers finish
    setTimeout(() => {
      historyActive.value = false;
    }, 150);
  }
});

const close = () => (historyActive.value = false);

defineExpose({
  close,
});
</script>

<style scoped src="./search-history-fi" />
